/**
 * Payment Gateway API Service
 * Handles Stripe configuration API calls
 */

import { apiClient } from './aiCrmApi';

// ===== Types =====

export interface PaymentGatewayConfig {
  id: string | null;
  gateway: string;
  isTestMode: boolean;
  isConfigured: boolean;
  lastTestedAt: string | null;
  lastTestResult: string | null;
  testPublishableKey: string | null;
  livePublishableKey: string | null;
  hasTestSecretKey: boolean;
  hasLiveSecretKey: boolean;
  hasTestWebhookSecret: boolean;
  hasLiveWebhookSecret: boolean;
}

export interface SavePaymentGatewayConfigRequest {
  isTestMode: boolean;
  testPublishableKey?: string;
  testSecretKey?: string;
  testWebhookSecret?: string;
  livePublishableKey?: string;
  liveSecretKey?: string;
  liveWebhookSecret?: string;
}

export interface TestConnectionResult {
  connected: boolean;
  accountId?: string;
  mode: 'test' | 'live';
}

// ===== API Functions =====

/**
 * Get payment gateway configuration
 */
export const getPaymentGatewayConfig = async (): Promise<PaymentGatewayConfig> => {
  const response = await apiClient.get('/payment-gateway/config');
  return response.data.data;
};

/**
 * Save payment gateway configuration
 */
export const savePaymentGatewayConfig = async (
  config: SavePaymentGatewayConfigRequest
): Promise<PaymentGatewayConfig> => {
  const response = await apiClient.post('/payment-gateway/config', config);
  return response.data.data;
};

/**
 * Test payment gateway connection
 */
export const testPaymentGatewayConnection = async (): Promise<TestConnectionResult> => {
  const response = await apiClient.post('/payment-gateway/test');
  return response.data.data;
};

/**
 * Toggle between test and live mode
 */
export const togglePaymentMode = async (isTestMode: boolean): Promise<{ isTestMode: boolean }> => {
  const response = await apiClient.put('/payment-gateway/mode', { isTestMode });
  return response.data.data;
};
